module.exports = __webpack_public_path__ + "img/2.46796db3.png";